import RangeToColorConverterBase from "./RangeToColorConverterBase.js";

class SymmetricRangeToColorConverter extends RangeToColorConverterBase{
    constructor(negativeRangeToColorConverter, positiveRangeToColorConverter){
        super();

        if (!(negativeRangeToColorConverter instanceof RangeToColorConverterBase)){
            throw new TypeError('negativeRangeToColorConverter must be an instance inheriting from RangeToColorConverterBase class');
        }

        if (!(positiveRangeToColorConverter instanceof RangeToColorConverterBase)){
            throw new TypeError('positiveRangeToColorConverter must be an instance inheriting from RangeToColorConverterBase class');
        }

        this.negativeRangeToColorConverter = negativeRangeToColorConverter;
        this.positiveRangeToColorConverter = positiveRangeToColorConverter;
    }

    getColor(from, to, min, max){
        if (to < 0){
            return this.negativeRangeToColorConverter.getColor(from, to, min, 0);
        }

        return this.positiveRangeToColorConverter.getColor(from, to, 0, max);
    }
}

export default SymmetricRangeToColorConverter;